import type React from 'react';

import { ComboBox, ComboBoxItem } from '@change/ds-forms';

import { withI18nPlaceholders } from '@change-corgi/core/react/i18n';

import I18N_PLACEHOLDERS from 'config/i18n/placeholders/growth/petition-place.yml';

import { usePlaceField } from '../hooks/usePlaceField';
import type { GeoScope, Place } from '../shared/types';

export type PlaceFieldSunriseProps = {
	label: string;
	placeholder?: string;
	labelIsVisible?: boolean;
	geoScope?: GeoScope;
	defaultPlaceValue?: Place | null;
	onSelect?: (place: Place | null) => void;
	error?: string | null;
};

const PlaceFieldSunriseComponent: React.FC<PlaceFieldSunriseProps> = ({
	geoScope,
	defaultPlaceValue = null,
	label,
	placeholder,
	labelIsVisible = true,
	onSelect,
	error,
}) => {
	const { placeInputValue, onPlaceInputChange, onPlaceChange, placePredictions } = usePlaceField({
		geoScope,
		defaultPlaceValue,
		onSelect,
	});

	return (
		<ComboBox<Place>
			name="petition-place"
			label={label}
			labelIsVisible={labelIsVisible}
			placeholder={placeholder}
			size="large"
			menuTrigger="input"
			allowsEmptyCollection
			showCaretDownIcon={false}
			inputValue={placeInputValue}
			onInputChange={onPlaceInputChange}
			onSelectionChange={(key) => {
				const place = placePredictions.find((p) => p.googlePlacesId === String(key));
				onPlaceChange(place ?? null);
			}}
			items={placePredictions}
			isInvalid={Boolean(error)}
			errorMessage={error ?? undefined}
			data-qa="petition-place"
		>
			{(place) => <ComboBoxItem id={place.googlePlacesId} label={place.displayName} />}
		</ComboBox>
	);
};

export const PlaceFieldSunrise = withI18nPlaceholders(I18N_PLACEHOLDERS, PlaceFieldSunriseComponent);
